import { render, staticRenderFns } from "./SearchWord.vue?vue&type=template&id=629423d5&scoped=true&lang=pug&"
import script from "./SearchWord.vue?vue&type=script&lang=js&"
export * from "./SearchWord.vue?vue&type=script&lang=js&"
import style0 from "./SearchWord.vue?vue&type=style&index=0&id=629423d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629423d5",
  null
  
)

export default component.exports